"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ROOM_JOINED = exports.SEARCHED_HELP = exports.OPENED_HELP = exports.DECLINED_TO_SHARE_MOTIVATION = exports.AGREED_TO_SHARE_MOTIVATION = exports.COMMENT_DELETED = exports.COMMENT_EDITED = exports.COMMENT_CREATED = exports.POST_DELETED = exports.POST_EDITED = exports.POST_CREATED = void 0; // Content

exports.POST_CREATED = "postCreated";
exports.POST_EDITED = "postEdited";
exports.POST_DELETED = "postDeleted";
exports.COMMENT_CREATED = "commentCreated";
exports.COMMENT_EDITED = "commentEdited";
exports.COMMENT_DELETED = "commentDeleted"; // Motivation Post

exports.AGREED_TO_SHARE_MOTIVATION = "agreedToShareMotivation";
exports.DECLINED_TO_SHARE_MOTIVATION = "declinedToShareMotivation"; // Help Widget

exports.OPENED_HELP = "openedHelp";
exports.SEARCHED_HELP = "searchedHelp"; // Rooms

exports.ROOM_JOINED = "roomJoined";